export const Log_in = "Logging in"
export const Log_out = "Logging out"